import { CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import {
  booleanAttribute,
  Component,
  HostListener,
  input,
} from '@angular/core';
import { CenterNoticeStatus } from '@malirang/common';
import { Badge, Icon } from '@malirang/front-share';

export interface ICenterNotice {
  id: string;
  title: string;
  content: string;
  status: keyof typeof CenterNoticeStatus;
  author: string;
  issuedAt?: string;
  expiredAt?: string;
  createdAt: string;
  order?: number;
  isPinned?: boolean;
}

@Component({
  selector: 'app-center-notice-card',
  templateUrl: './center-notice-card.component.html',
  imports: [CommonModule, Badge, CdkDrag, CdkDragHandle, Icon],
})
export class CenterNoticeCard {
  @HostListener('click', ['$event'])
  onClick(event: MouseEvent) {
    if (this.orderMode()) {
      event.stopPropagation();
    }
  }

  orderMode = input<boolean>(false);
  notice = input.required<ICenterNotice>();
  invisibleBadge = input<boolean, string>(false, {
    transform: booleanAttribute,
  });
}
